// @ts-nocheck

import {customAlphabet} from "nanoid";

export type InboxDatabaseConfigurationReport = {
  nameProperty: string | null | undefined
  fromProperty: string | null | undefined
  fromType: string | null | undefined
  toProperty: string | null | undefined
  toType: string | null | undefined
  dateReceivedProperty: string | null | undefined
  attachmentsProperty: string | null | undefined
  previewImageProperty: string | null | undefined
  emailImageProperty: string | null | undefined
  emailTextProperty: string | null | undefined
  replyToProperty: string | null | undefined

}

export const getPropertyKeyIfExists = (db: any, property: string, type: string): string | null => {
  const [originalPropertyKey, value] = Object
    .entries(db?.properties)
    .find(([key, values]) => key.toLowerCase() === property.toLowerCase()) || []

  if (value) {
    if (type) {
      if (value?.['type'] === type) {
        return originalPropertyKey
      } else {
        return null
      }
    } else {
      return originalPropertyKey
    }
  } else {
    return null
  }

}

export const getTitlePropertyKey = (db: any): string | null => {
  const [originalPropertyKey, value] = Object
    .entries(db?.properties)
    .find(([key, value]) => value?.['type'] === "title") || []
  return originalPropertyKey

}
export type InboxFieldNames = {
  name: string;
  from: string;
  to: string;
  dateReceived: string;
  attachments: string;
  previewImage: string;
  emailImage: string;
  emailText: string;
  replyTo: string;
};

export const defaultInboxFieldNames: InboxFieldNames = {
  from: "from",
  to: "to",
  dateReceived: "date received",
  attachments: "attachments",
  previewImage: "preview",
  emailImage: "email image",
  emailText: "email text",
  replyTo: "reply to"
};


export const getInboxDatabaseReport = (db: any, fieldNames: InboxFieldNames | undefined | null): InboxDatabaseConfigurationReport => {

  const effectiveFieldNames: InboxFieldNames = {...defaultInboxFieldNames, ...(fieldNames || {})};

  const nameProperty = getTitlePropertyKey(db)
  const fromEmail = getPropertyKeyIfExists(db, effectiveFieldNames.from, "email")
  const fromRichText = getPropertyKeyIfExists(db,  effectiveFieldNames.from, "rich_text")
  const toEmail = getPropertyKeyIfExists(db,  effectiveFieldNames.to, "email")
  const toRichText = getPropertyKeyIfExists(db, effectiveFieldNames.to, "rich_text")
  const dateExists = getPropertyKeyIfExists(db, effectiveFieldNames.dateReceived, "date")
  const attachments = getPropertyKeyIfExists(db, effectiveFieldNames.attachments, "files")
  const preview = getPropertyKeyIfExists(db, effectiveFieldNames.previewImage, "files")
  const image = getPropertyKeyIfExists(db, effectiveFieldNames.emailImage, "files")
  const emailText = getPropertyKeyIfExists(db, effectiveFieldNames.emailText, "rich_text")
  const replyTo = getPropertyKeyIfExists(db, effectiveFieldNames.replyTo, "relation")

  return {
    nameProperty: nameProperty,
    fromProperty: fromEmail ?? fromRichText,
    fromType: fromEmail ? "email" : (fromRichText ? "rich_text" : null),
    toProperty: toEmail ?? toRichText,
    toType: toEmail ? "email" : (toRichText ? "rich_text" : null),
    dateReceivedProperty: dateExists,
    attachmentsProperty: attachments,
    previewImageProperty: preview,
    emailImageProperty: image,
    emailTextProperty: emailText,
    replyToProperty: replyTo
  }
}

export const generateKey = () => {
  const nanoid = customAlphabet('1234567890abcdefghijklmnopqrstuvwxyz', 4)
  const emailKey = nanoid()
  return emailKey
}
